// @aiContributed-2025-10-28
import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedAddTextStepWithI18n =
  () => import(/* webpackChunkName: 'campaign-add-text-step.async' */'./add-text-step')
    .then(({ AddTextStepWithI18n }) => AddTextStepWithI18n);

const DelayedAddTextLazyRepository =
  () => import(/* webpackChunkName: 'add-text-lazy-repository.async' */'./add-text-lazy-repository')
    .then(({ AddTextLazyRepositoryWithI18n }) => AddTextLazyRepositoryWithI18n);

export const SearchCampaignAddTextStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_ADD_TEXT,
  view: DelayedAddTextStepWithI18n,
  repository: DelayedAddTextLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
  viewProps: {
    enableAdsManagment: false,
    isSignup: true,
  },
  repositoryProps: {
    adTypes: ['ResponsiveSearch', 'Responsive'],
  },
};
